/**
 * Whether the tab is currently visible.
 *
 * Polling hooks use this to skip refetches while the operator is on another
 * tab, so a background dashboard does not keep hitting the BFF. Guarded for
 * environments without `document` (and for jsdom, where `visibilityState` is
 * always 'visible').
 */
export const isTabVisible = (): boolean =>
  typeof document === 'undefined' || document.visibilityState === 'visible';
